import React, { PropsWithChildren, FC } from "react";
import Animated from "../Animated";

export interface FadeProps extends PropsWithChildren<{}> {
  in: boolean;
  timeout?: number;
  onExited?: () => void;
  unmountOnExit?: boolean;
}

const Fade: FC<FadeProps> = props => {
  const { children, in: inProp, timeout, onExited, ...rest } = props;

  return (
    <Animated
      in={inProp}
      name="fade"
      timeout={timeout}
      onExited={onExited}
      {...rest}
    >
      {children}
    </Animated>
  );
};

export default Fade;
